module.exports = __webpack_public_path__ + "img/teamfaktor-logo-small.4a67449c.svg";